
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 47","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.23 33.33V5.65C54.23 3.63 52.6 2 50.58 2H8.65C6.63 2 5 3.63 5 5.65v29.57c0 2.02 1.63 3.65 3.65 3.65h14.68v3.65H19.3c-.55 0-1 .45-1 1s.45 1 1 1h20.65c.55 0 1-.45 1-1s-.45-1-1-1h-4.1v-3.65H50.6c2.02 0 3.65-1.63 3.65-3.65v-1.88l-.02-.01zM8.65 4h41.93c.91 0 1.65.74 1.65 1.65v26.68H7V5.65C7 4.74 7.74 4 8.65 4zm25.19 38.51h-8.51v-3.65h8.51v3.65zm16.75-5.65H8.65c-.91 0-1.65-.74-1.65-1.65v-.88h45.23v.88c0 .91-.74 1.65-1.65 1.65h.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M23.1 25.63c.3.18.67.2.98.04l12.64-6.42a1 1 0 00.55-.89 1 1 0 00-.55-.89l-12.64-6.42c-.31-.16-.68-.14-.98.04-.3.18-.48.5-.48.85v12.83c0 .35.18.67.48.85v.01zm1.52-2.48v-9.57l9.43 4.79-9.43 4.79v-.01z","fill":"currentColor"}})])
          )
        }
      }
    